import React from 'react';
import { useParams } from 'react-router-dom';
import GuestPayerDetailSections from './GuestPayerDetailSections';

const GuestPayerDetail = () => {
  const { number } = useParams();

  return (
    <div>
      <GuestPayerDetailSections loanNumber={number} />
    </div>
  );
};

export default GuestPayerDetail;
